import { render } from "./ProsesProcurement.vue?vue&type=template&id=5a92ccd7"
import script from "./ProsesProcurement.vue?vue&type=script&lang=js"
export * from "./ProsesProcurement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__